var _circle, _circle2, _circle3, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.45,
    cx: 48,
    cy: 48,
    r: 33.75,
    stroke: "#ED4B68",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.45,
    cx: 48,
    cy: 48,
    r: 40.75,
    stroke: "#ED4B68",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.45,
    cx: 48,
    cy: 48,
    r: 47.75,
    stroke: "#ED4B68",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2122_12365)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#ED4B68"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2122_12365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9209 57C38.7537 57 38.5813 56.9645 38.4141 56.8936L27 51.902L38.556 49.3885L37.0101 38.5135L45.1095 43.9003L53.7157 33L54.5165 44.6757L60.7608 43.8547L59.8535 49.8041L67 52.6875L58.3583 56.5693C57.7197 56.8581 56.9696 56.5693 56.6858 55.9307C56.3969 55.2922 56.6858 54.5422 57.3244 54.2584L60.5428 52.8142L57.0507 51.4054L57.7501 46.8091L52.1799 47.5439L51.6427 39.7297L45.6569 47.3108L40.3198 43.7635L41.3994 51.375L35.1906 52.728L39.4379 54.5828C40.0816 54.8615 40.3705 55.6115 40.0917 56.25C39.8839 56.7264 39.4176 57.0101 38.9311 57.0101L38.9209 57Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2122_12365",
    x: 7.61664,
    y: 9.75797,
    width: 80.7667,
    height: 80.7667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.14134
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.69168
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2122_12365"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2122_12365",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2122_12365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    fill: "white",
    transform: "translate(27 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoc);
export default __webpack_public_path__ + "static/media/choc.24abc4041b1ec0a3ede9d1c192a851e9.svg";
export { ForwardRef as ReactComponent };